import React from 'react';
import { remove } from 'ramda';
import {
  IExtendedConditionObject,
  IUIPage,
} from '../../../../../../Types/UrvalTypes';
import { ExtendedOperatorType } from '../../../../../../Types/ClientModelTypes';
import ExtendedUrval from './Components/ExtendedUrval/ExtendedUrval';
import { setCondition } from '../../Utils/UrvalConditionObjectUtils';
import {
  setInPages,
  setExtendedOperator,
} from '../../Utils/UrvalExtendedConditionObjectUtils';

interface IProps {
  conditionObject: IExtendedConditionObject;
  setConditionObject: (newConditionObject: IExtendedConditionObject) => void;
  deleteConditionObject: () => void;
  indention: number;
  disabled?: boolean;
}

class ExtendedCondition extends React.Component<IProps> {
  setInPages = (index: number) => (newInPages: IUIPage[]) => {
    this.props.setConditionObject(
      setInPages(index, newInPages, this.props.conditionObject)
    );
  };

  setOperator = (index: number) => (newOperator: ExtendedOperatorType) => {
    this.props.setConditionObject(
      setExtendedOperator(index, newOperator, this.props.conditionObject)
    );
  };

  removeExtendedCondition = (index: number) => () => {
    const newExtendedConditions = remove(
      index,
      1,
      this.props.conditionObject.condition
    );

    if (newExtendedConditions.length === 0) {
      this.props.deleteConditionObject();
    } else {
      this.props.setConditionObject(
        setCondition(newExtendedConditions, this.props.conditionObject)
      );
    }
  };

  render() {
    return this.props.conditionObject.condition.map(
      (extendedCondition, index) => (
        <ExtendedUrval
          conditionObject={this.props.conditionObject}
          setConditionObject={this.props.setConditionObject}
          key={extendedCondition.id}
          operator={extendedCondition.op}
          inPages={extendedCondition.in}
          setInPages={this.setInPages(index)}
          setOperator={this.setOperator(index)}
          association={this.props.conditionObject.association}
          modelPath={this.props.conditionObject.modelPath || []}
          removeExtendedCondition={this.removeExtendedCondition(index)}
          indention={this.props.indention}
          disabled={this.props.disabled}
        />
      )
    );
  }
}

export default ExtendedCondition;
